"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _helpers = require("@qwkin/helpers");
var _theme = require("../utils/theme");
var _Button = require("./Button.styles");
var _Icon = require("../Icon");
var _excluded = ["theme", "backgroundColor", "foregroundColor", "children", "icon", "themeColor", "outline", "disabled", "dense", "full", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Button = function Button(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    backgroundColor = _ref.backgroundColor,
    foregroundColor = _ref.foregroundColor,
    children = _ref.children,
    icon = _ref.icon,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? _theme.defaultTheme.color.primary : _ref$themeColor,
    outline = _ref.outline,
    disabled = _ref.disabled,
    dense = _ref.dense,
    full = _ref.full,
    onClick = _ref.onClick,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isSelected = _useState2[0],
    setSelected = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Button.PlainButton, (0, _extends2["default"])({
    onMouseOver: function onMouseOver() {
      return setSelected(true);
    },
    onMouseOut: function onMouseOut() {
      return setSelected(false);
    },
    onMouseDown: function onMouseDown() {
      return setSelected(true);
    },
    onMouseUp: function onMouseUp() {
      return setSelected(false);
    },
    isSelected: isSelected,
    themeColor: themeColor,
    outline: outline,
    backgroundColor: backgroundColor,
    foregroundColor: foregroundColor,
    disabled: disabled,
    dense: dense,
    onClick: disabled ? _helpers.identity : onClick
  }, props), icon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    size: 24,
    icon: icon,
    color: (0, _Button.buildButtonColor)({
      outline: outline,
      disabled: disabled,
      foregroundColor: foregroundColor,
      themeColor: themeColor,
      theme: theme
    })
  }), /*#__PURE__*/_react["default"].createElement(_Button.ChildrenContainer, (0, _extends2["default"])({
    full: full
  }, props), children)));
};
Button.defaultProps = {
  onClick: _helpers.identity,
  outline: null
};
var _default = exports["default"] = Button;